module.exports = __webpack_public_path__ + "static/media/GothamRnd-Book.e40570a3.otf";